import FilterParamsUtil from '../../sections/collection-grid/filter-params-util'


const CollectionFilterSpDetails = (el, onClose) => {


  let filterParams = []


  const initialize = () => {
    el.querySelector('.fs-back-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(false, null)
    })
    el.querySelector('.fs-close-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(true, null)
    })
    el.querySelector('.fs-clear-button').addEventListener('click', () => {
      const newFilterParams = filterParams.filter(kv => !kv.key.startsWith('meta.custom.detail_')).filter(kv => !kv.key.startsWith('detail_length_'))
      handleChangeFilterParams(newFilterParams, true)
    })
    el.querySelector('.fs-select-button').addEventListener('click', () => {
      el.classList.remove('show')
      onClose(false, filterParams)
    })
    el.querySelectorAll('.fs-header-row').forEach(headerRow => {
      headerRow.addEventListener('click', e => {
        headerRow.parentElement.classList.toggle('show')
      })
    })
    el.querySelectorAll('input[type=checkbox]').forEach(input => {
      input.addEventListener('change', e => {
        if (e.target.name == 'detail_length_range_enabled') {
          if (e.target.checked) {
            el.querySelector('.fs-range-row-container')?.classList.add('show')
          } else {
            const newFilterParams = filterParams.filter(kv => !kv.key.startsWith('detail_length_'))
            handleChangeFilterParams(newFilterParams)
          }
          return
        }
        if (e.target.checked) {
          handleChangeFilterParams([...filterParams, {key: e.target.name, value: e.target.value}])
          return
        }
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name || kv.value != e.target.value)
        handleChangeFilterParams(newFilterParams)
      })
    })
    el.querySelectorAll('input[type=number]').forEach(input => {
      input.addEventListener('input', e => {
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name)
        if (!e.target.value || e.target.value.length <= 0) {
          handleChangeFilterParams(newFilterParams)
        } else {
          handleChangeFilterParams([...newFilterParams, {key: e.target.name, value: e.target.value}])
        }
      })
    })
  }


  const show = (newFilterParams) => {
    filterParams = FilterParamsUtil.duplicate(newFilterParams)
    handleChangeFilterParams(newFilterParams, true)
    el.classList.add('show')
  }


  const handleChangeFilterParams = (newFilterParams, initial = false) => {
    if (filterParams == newFilterParams) {
      return
    }
    el.querySelectorAll('input[type=checkbox]').forEach(input => {
      input.checked = false
      if (0 <= newFilterParams?.findIndex(kv => kv.key == input.name && kv.value == input.value)) {
        input.checked = true
      }
    })
    el.querySelectorAll('input[type=number]').forEach(input => {
      input.value = newFilterParams?.find(kv => kv.key == input.name)?.value ?? null
    })

    if (0 <= newFilterParams.findIndex(kv => kv.key.startsWith('detail_length_'))) {
      el.querySelector('input[name=detail_length_range_enabled]').checked = true
      el.querySelector('.fs-range-row-container')?.classList.add('show')
    } else {
      el.querySelector('input[name=detail_length_range_enabled]').checked = false
      el.querySelector('.fs-range-row-container')?.classList.remove('show')
    }

    if (initial) {
      if (0 <= newFilterParams.findIndex(kv => kv.key == 'meta.custom.detail_sleeve')) {
        el.querySelector('.fs-submenu.sleeve').classList.add('show')
      } else {
        el.querySelector('.fs-submenu.sleeve').classList.remove('show')
      }
      if (0 <= newFilterParams.findIndex(kv => kv.key == 'meta.custom.detail_length')
          || 0 <= newFilterParams.findIndex(kv => kv.key.startsWith('detail_length_'))
      ) {
        el.querySelector('.fs-submenu.length').classList.add('show')
      } else {
        el.querySelector('.fs-submenu.length').classList.remove('show')
      }
      if (0 <= newFilterParams.findIndex(kv => kv.key == 'meta.custom.detail_silhouette')) {
        el.querySelector('.fs-submenu.silhouette').classList.add('show')
      } else {
        el.querySelector('.fs-submenu.silhouette').classList.remove('show')
      }
    }

    filterParams = newFilterParams
  }


  initialize()

  return {
    show: show
  }
}


export default CollectionFilterSpDetails
